// The roles a staff member can hold, with what each one gives access to.
// A person can hold several (stored comma-joined, e.g. "SALES,SALEADMIN").
export interface StaffRoleOption {
  value: string;
  label: string;
  description: string;
  badgeClass: string;
  superOnly?: boolean;
}

export const STAFF_ROLES: StaffRoleOption[] = [
  { value: 'S-ADMIN', label: 'Super Admin', description: 'Everything, including purchasing, the dashboard and inventory.', badgeClass: 'bg-neutral-900 text-amber-400', superOnly: true },
  { value: 'ADMIN', label: 'Admin', description: 'Full back-office access, including products, categories, coupons and settings.', badgeClass: 'bg-red-100 text-red-700' },
  { value: 'SALEADMIN', label: 'Sales Admin', description: 'Sales plus coupons, trade requests and the sales team.', badgeClass: 'bg-purple-100 text-purple-700' },
  { value: 'SALES', label: 'Sales', description: 'Create and manage sales orders.', badgeClass: 'bg-blue-100 text-blue-700' },
  { value: 'DELIVERY', label: 'Delivery', description: 'Dispatch, returns, stock scrap and incoming stocks. Alone, only those screens show.', badgeClass: 'bg-orange-100 text-orange-700' },
  { value: 'MARKETING', label: 'Marketing', description: 'Content, coupons, emails and campaigns, affiliate and reports, products, inventory, categories, sales, dashboard. Alone, only those show.', badgeClass: 'bg-teal-100 text-teal-700' },
  { value: 'PURCHASE', label: 'Purchase', description: 'Purchase orders, shipments and suppliers. Alone, only those screens show.', badgeClass: 'bg-fuchsia-100 text-fuchsia-700' },
];

export function staffRole(value: string): StaffRoleOption | undefined {
  return STAFF_ROLES.find((r) => r.value === value);
}
